export const contactAddress = {
	'name'    : 'Sun Twilight',
	'street'  : 'Metro Street',
	'locality': 'Opposite Delta-1 Metro Station, Rep-2A, Sector 27, Greater Noida',
	'state'   : 'Uttar Pradesh',
	'pin'     : '201308',
	'country' : 'India'
};
export const contactEmail = 'hello@overseas.one';
